import { Button, Form, message, Modal, Select, Space, Typography } from "antd";
import { debounce, get } from "lodash";
import React, { useCallback, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BooleanReturnType } from "../../hooks/use-boolean";
import { useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance, { endpoints } from "../../services/axios";

const AddAdvanceDialog = ({
  modalBool,
  refetch,
  companyList,
}: {
  modalBool: BooleanReturnType;
  refetch: any;
  companyList: { key: string; label: string; value: string }[];
}) => {
  const [form] = Form.useForm();
  const [search, setSearch] = useState("");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { data: users, isFetching: userFetching } = useQuery({
    queryKey: ["md-user", search],
    queryFn: async () => {
      axiosInstance.defaults.headers.common.Authorization = token;
      return await axiosInstance.get(
        endpoints.employee.search(search ? "?search=" + search : "")
      );
    },
    enabled: !!search,
  });

  const usersList = useMemo(
    () =>
      get(users, "data.data", []).map((item: any) => ({
        value: item.id,
        key: item.id,
        disabled: !item.enabled,
        label: `${item.name || ""} ${item.lastName || ""}`,
      })),
    [users]
  );

  const { mutate: createEmployee, isPending } = useMutation({
    mutationFn: async (data: { bxUserId: string }) =>
      await axiosInstance.post(endpoints.employee.advanceBlacklistAdd(data.bxUserId)),
    onSuccess: () => {
      message.success("Successfully created!");
      cancel();
    },
  });

  const onFinish = useCallback(
    (data: { bxUserId: string }) => {
      createEmployee(data);
    },
    [createEmployee]
  );

  const cancel = () => {
    modalBool.onFalse();
    form.resetFields();
    refetch();
  };
  return (
    <Modal
      open={modalBool.value}
      title={
        <Typography.Title className="m-0" level={5}>
          Create new Employee
        </Typography.Title>
      }
      closable={false}
      footer={null}
    >
      <Form onFinish={onFinish} form={form} layout="vertical">
        <Form.Item
          name={"bxUserId"}
          label="User"
          rules={[{ required: true, message: "Please enter user!" }]}
        >
          <Select
            options={usersList}
            onSearch={debounce(setSearch, 400)}
            loading={userFetching}
            showSearch
            placeholder="Search users..."
            defaultActiveFirstOption={false}
            filterOption={false}
            notFoundContent={null}
          />
        </Form.Item>

        <Form.Item className="flex justify-end mb-0">
          <Space>
            <Button onClick={cancel}>Cancel</Button>
            <Button loading={isPending} type="primary" htmlType="submit">
              Add
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default AddAdvanceDialog;
